import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Input from '../reuseable/Input';
import { get_toolbox_mode_list } from '../../App/validation/toolbox_mode_list';
import { set_value_toolbox } from '../../App/actions/toolboxActions';
import circle from '@turf/circle';
import useLanguage from '../common_hooks/useLanguage';

function SETTING_RADIUS() {
  const { map_object } = useSelector((state) => (state.layer));
  const toolbox = useSelector((state) => (state.toolbox)) || {};
  const { name_toolbox, uuid_name, mode_toolbox } = toolbox;
  const [radius, set_radius] = useState("-");

  const selected_row_toolbox_ids = toolbox[uuid_name];
  const features = toolbox[mode_toolbox];
  const tool = get_toolbox_mode_list(mode_toolbox);
  const unit_options = tool?.unit_options || [];
  const [unit, set_unit] = useState(unit_options?.[0] || "");

  const dispatch = useDispatch();
  const { dict, language } = useLanguage();

  const generate_radius = () => {
    const geojson = {
      type: "FeatureCollection",
      features: [],
    };

    const new_features = features.map(f => {
      let meter, kilometer;
      if (!selected_row_toolbox_ids.includes(f.properties.uuid)) {
        geojson.features.push(circle(f, f.properties.radius_km, {
          steps: 100,
          units: "kilometers",
          properties: f.properties,
        }))
        return f
      };

      if (unit === "meter") {
        meter = radius;
        kilometer = radius / 1000
      } else {
        kilometer = radius;
        meter = radius * 1000;
      }

      const new_feature = {
        ...f,
        properties: {
          ...f.properties,
          radius_m: parseFloat(meter),
          radius_km: parseFloat(kilometer)
        }
      }

      geojson.features.push(circle(new_feature, new_feature.properties.radius_km, {
        steps: 100,
        units: "kilometers",
        properties: new_feature.properties,
      }))

      return new_feature
    })

    map_object?.getSource("geojson_radius").setData(geojson)

    dispatch(set_value_toolbox({
      key: mode_toolbox,
      value: new_features
    }))

  }

  const change_unit = (value) => {
    if (unit_options.includes(value)) set_unit(value)
  }

  const on_change_radius = (e) => {
    const value = parseFloat(e.target.value);
    set_radius(value);
  }

  return (
    <div
      style={{
        width: "230px",
        // width: "360px",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        margin: "10px 0 10px 0"
      }}
    >
      {name_toolbox &&
        <section
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <div
            style={{
              fontWeight: 700,
              fontSize: "16px",
              lineHeight: "19px",
              color: "#000000",
            }}
          >
            {language === "ina" && `${dict["Setting"][language]} `}
            {`${name_toolbox}`}
            {language === "eng" && ` ${dict["Setting"][language]}`}
          </div>

          {/* {selected_row_toolbox_ids?.length > 0 &&  */}
          <div
            style={{
              fontSize: "12px",
              color: "#000000",
            }}
          >
            {`${selected_row_toolbox_ids?.length} ${dict["Selected"][language]}`}
          </div>
          {/* } */}
        </section>
      }

      <hr />

      <section
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#F5F5F5",
          padding: "6px 8px",
          marginBottom: "15px",
          borderRadius: "15px"
        }}
      >
        <div
          className='center_perfect'
          style={{
            width: "160px",
            height: "29px",
            borderRadius: "5px",
            backgroundColor: unit === "meter" ? "#fff" : "#ffffff00",
            fontWeight: unit === "meter" ? "700" : "400",
            cursor: "pointer",
            fontSize: "14px"
          }}
          onClick={() => change_unit("meter")}
        >
          {dict["Meters"][language]}
        </div>
        <div
          className='center_perfect'
          style={{
            width: "160px",
            height: "29px",
            borderRadius: "5px",
            backgroundColor: unit === "kilometer" ? "#fff" : "#ffffff00",
            fontWeight: unit === "kilometer" ? "700" : "400",
            cursor: "pointer",
            fontSize: "14px"
          }}
          onClick={() => change_unit("kilometer")}
        >
          {dict["Kilometers"][language]}
        </div>
      </section>

      <section>
        <span style={{ fontSize: "14px" }}>{`${dict["Change radius"][language]} (${unit})`}</span>
        <Input
          style={{ margin: "15px 0 15px 0" }}
          value={radius}
          type="number"
          onChange={(e) => on_change_radius(e)}
        />
      </section>

      <section>
        <button
          style={{
            backgroundColor: !isNaN(radius) ? "black" : "#ABABAB",
            color: "white",
            width: "100%",
            borderRadius: "15px",
            height: "40px",
            fontSize: "14px"
          }}
          onClick={() => { if (!isNaN(radius)) generate_radius() }}
        >
          {dict["Generate"][language]}
        </button>
      </section>
    </div >
  )
}

export default SETTING_RADIUS